// ProCraft Solutions — site content
// Edit this file to update copy, services, and reviews.

export const BRAND = {
  name: "ProCraft Solutions",
  tagline: "Build Smart. From The Start.",
  phone: "727-266-9625",
  phoneHref: "tel:7272669625",
  email: "ProCraftSolutions@yahoo.com",
  email2: "Myprocraftsolutions@gmail.com",
  facebook: "https://www.facebook.com/107213409100427",
  logo: "https://customer-assets.emergentagent.com/job_afe891bf-64b6-4f66-b76b-d9feccee4820/artifacts/0uenw5ew_680033268_2935458509989290_3402286602520050507_n.jpg",
};

// NOTE: Only unique, non-duplicate photos. Hero image for each item controls layout span.
export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/ymis335j_image.png",
    alt: "Backyard turf install & paver edging — before and after",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/e4u1c7gn_image.png",
    alt: "Side-yard mulch tear-out & palm + white-rock garden",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/aayi0l6a_image.png",
    alt: "Waterfront patio — stamped concrete, custom planter box & flower bed",
    span: "lg:col-span-8 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/onaftn6y_image.png",
    alt: "Side-yard transformation — turf to paver pathway with tropical landscaping",
    span: "lg:col-span-4",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/g9w27qvp_image.png",
    alt: "Paver walkway day-to-night — landscape lighting reveal",
    span: "lg:col-span-4",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/wbtoxb3k_image.png",
    alt: "Front-yard remodel — fresh sod, palm & manicured beds",
    span: "lg:col-span-4",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/6t9h087m_image.png",
    alt: "Lawn restoration with stepping-stone walkway — before & after",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/bdjajbnu_image.png",
    alt: "Backyard cleanup & custom wood privacy screen",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_afe891bf-64b6-4f66-b76b-d9feccee4820/artifacts/q21mfpnn_679606644_1308554367382780_2217594484396914297_n.jpg",
    alt: "Full landscape remodel — before and after",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_afe891bf-64b6-4f66-b76b-d9feccee4820/artifacts/13pqp6el_678392247_942405208398108_8528729751303038188_n.jpg",
    alt: "Front yard sod restoration — before and after",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/rl6sdd3l_680258579_941537105535829_3341124945755979081_n.jpg",
    alt: "Side-yard rock garden remodel — before and after",
    span: "lg:col-span-4",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/srtblnmx_679543285_1267591722024362_2838961773005782927_n.jpg",
    alt: "French drain installation — full process",
    span: "lg:col-span-4",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_afe891bf-64b6-4f66-b76b-d9feccee4820/artifacts/fasoawgs_679915024_1786222586116861_2083616639220140145_n.jpg",
    alt: "Paver patio build & landscaping",
    span: "lg:col-span-4",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/l1wqj6md_675503223_1242688001005636_5462268088969677252_n.jpg",
    alt: "Backyard paver patio & fence project",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/7rfzmp8s_680959033_1479445516965431_4452153037502166927_n.jpg",
    alt: "Raised garden bed & sod install — before and after",
    span: "lg:col-span-6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_afe891bf-64b6-4f66-b76b-d9feccee4820/artifacts/7a22rt2k_681127893_2164717654292067_6155819966692967926_n.jpg",
    alt: "Luxury new-build landscape — before and after",
    span: "lg:col-span-12",
  },
];

// Project videos — short clips of real ProCraft Solutions work, looped silently.
export const VIDEOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/1xw64hfl_AQMMr_Rf-2c8YtofovpJ5pZ5Xd9O1MiP1KW4t9AcqJ3fwRIvia2tRl2qy01EgYernDiXug98ZlVbQUG3gD-qsLV6AmWkNsR0pYDoiELZ-A.mp4",
    title: "On-site walk-through",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/6jf6nhaz_AQOnJVwoPgc0tm3RiQOfuFU22UxPUUWCrjTJUOWaUOQjjLYBrikDi_Yw0FiRnDPT9imqa5aj1MztroL3d30EQu6490HfG9UwUH9b2MafyA.mp4",
    title: "Project in progress",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/95dsmpyc_AQMVirMH7nzBcYtyMVnhe7H3eh_552Lw4MZP-lOKfPpoaZlsplM3RiyALp4wBr_VYdfumMMw6ePoFEqB6rLJhYnlb0uGWmrnOk1K6UZHnA.mp4",
    title: "Finished result",
  },
];

export const SERVICES = [
  {
    slug: "landscaping",
    title: "Landscaping",
    short: "Full remodels — tear out to put back. Beds, sod, plants, finishes.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/wbtoxb3k_image.png",
    overview:
      "Full-scope landscaping — from a clean tear-out to a brand-new finished yard. We handle every step so you get one crew, one quote, and one transformed property. Beds, sod, trees, shrubs, mulch, rock, borders, and final clean-up.",
    includes: [
      "On-site walk-through & design plan",
      "Full tear-out of existing beds, sod, or overgrowth",
      "Grading, site prep, and soil amendment",
      "New sod, plants, trees & shrubs",
      "Mulch, river rock, and crisp bed edging",
      "Irrigation check and final property clean-up",
    ],
    faq: [
      {
        q: "Can you start with a complete tear-out?",
        a: "Absolutely — 'tear out to put back' is one of our most-requested packages. We remove everything down to dirt, then rebuild the yard from scratch with the plan you approve.",
      },
      {
        q: "How long does a full remodel take?",
        a: "Most residential remodels finish in 3–10 working days depending on scope. We give a clear timeline before we break ground.",
      },
      {
        q: "Do you handle the design too?",
        a: "Yes. Design and install are in-house so what you approve is what you get — no outsourcing, no surprises.",
      },
    ],
  },
  {
    slug: "monthly-lawn-maintenance",
    title: "Monthly Lawn Maintenance",
    short: "Package deals for weekly, bi-weekly & monthly lawn care.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/js885s6l_665851214_1785095105787652_6055593490093181374_n.jpg",
    overview:
      "Flat-rate monthly lawn maintenance package deals built for Tampa Bay properties. Pick the plan that fits your yard and we keep it sharp week after week — mow, edge, trim, blow, and go.",
    includes: [
      "Weekly, bi-weekly, or monthly package options",
      "Mowing, edging, and string trimming",
      "Hedge & shrub trimming",
      "Blowing of all hard surfaces",
      "Weed control in beds and edges",
      "Optional add-ons: fertilization, pest, seasonal cleanup",
    ],
    faq: [
      {
        q: "What's included in the package price?",
        a: "Every visit includes mow, edge, trim, and blow-off at no extra charge. Add-on services (fertilization, pest, hedge reshaping) are quoted separately so you only pay for what you need.",
      },
      {
        q: "How often will you come?",
        a: "Weekly during the growing season, bi-weekly in the cooler months. We tailor the schedule to your property and budget.",
      },
      {
        q: "Are you licensed and insured?",
        a: "Yes — fully licensed and insured for both residential and commercial accounts.",
      },
    ],
  },
  {
    slug: "sod-installation",
    title: "Sod Installation",
    short: "Fresh sod install — bare or patchy yards to lush, green lawns.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/0257wo8j_image.png",
    overview:
      "New sod is the fastest way to transform a tired yard into a lush, green lawn. We tear out the old, prep the soil, and lay fresh Florida-friendly sod (St. Augustine, Zoysia, Bahia) so you get instant curb appeal that lasts.",
    includes: [
      "Site prep & removal of old grass/weeds",
      "Soil grading & top-dressing as needed",
      "Fresh sod — St. Augustine, Zoysia, or Bahia",
      "Tight-seam install with rolled finish",
      "Initial watering & care instructions",
      "Optional add-on: fertilization & follow-up maintenance",
    ],
    faq: [
      {
        q: "Which type of sod is best for my yard?",
        a: "It depends on sun exposure, foot traffic, and budget. St. Augustine is the Florida favorite for shade tolerance; Zoysia is durable and drought-tolerant; Bahia is the most affordable for large sunny lots. We walk your property and recommend what fits.",
      },
      {
        q: "How soon can I walk or mow on new sod?",
        a: "Keep foot traffic light for the first 2 weeks. First mow around 2-3 weeks in, once the roots have set. We leave you with a full care schedule so it takes.",
      },
      {
        q: "Do you handle watering & follow-up?",
        a: "We'll walk you through the watering schedule the day of install, and we offer follow-up maintenance packages to protect your investment.",
      },
    ],
  },

  {
    slug: "landscape-lighting",
    title: "Landscape Lighting",
    short: "Architectural & path lighting that makes your home glow after dark.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/g9w27qvp_image.png",
    overview:
      "Landscape lighting adds curb appeal, safety, and a resort-style feel to any property. We design layouts that highlight architecture, trees, and pathways using durable, low-voltage fixtures.",
    includes: [
      "Custom lighting plan & fixture selection",
      "Path, uplight, downlight & accent zones",
      "Low-voltage transformer install",
      "Smart timers & photocells",
      "Wiring buried for a clean look",
      "Annual tune-up plans",
    ],
    faq: [
      {
        q: "Do you offer smart-controlled lighting?",
        a: "Yes — timers, dusk-to-dawn sensors, and smart-app controlled systems available on request.",
      },
      {
        q: "Will the wiring be visible?",
        a: "No. All wiring is buried and tucked along beds for a clean, professional finish.",
      },
    ],
  },
  {
    slug: "drainage",
    title: "Drainage",
    short: "Stop standing water, protect your foundation, save your lawn.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/7rfzmp8s_680959033_1479445516965431_4452153037502166927_n.jpg",
    overview:
      "Florida rain doesn't play around. We diagnose problem areas and engineer drainage systems that move water away from your home, beds, and walkways before they become expensive problems.",
    includes: [
      "On-site drainage assessment",
      "French drains & catch basins",
      "Downspout extensions & pop-up emitters",
      "Channel drains for driveways & patios",
      "Yard regrading where needed",
      "Pump systems for low-lying areas",
    ],
    faq: [
      {
        q: "Will my lawn be torn up?",
        a: "We use clean trenching methods and restore sod the same day in most cases. You'll barely know we were there.",
      },
      {
        q: "Do you warranty drainage work?",
        a: "Yes — labor and materials are warrantied. Ask for details during your estimate.",
      },
    ],
  },
  {
    slug: "retaining-walls",
    title: "Retaining Walls",
    short: "Block, stone & timber walls that hold the line — and look sharp.",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_craft-solutions-new/artifacts/jw2v67jx_image.png",
    overview:
      "Retaining walls solve real problems — erosion, sloped yards, flower-bed boundaries, and grade changes — while adding a premium finished look to your landscape. We build segmental block, natural stone, and timber walls that are engineered to last.",
    includes: [
      "Site grading & excavation",
      "Compacted gravel base with drainage provisions",
      "Segmental block, natural stone, or timber options",
      "Geo-grid reinforcement on taller walls",
      "Integrated planter beds & seat walls",
      "Final backfill, cap, and sod restoration",
    ],
    faq: [
      {
        q: "How tall can you build a retaining wall?",
        a: "We regularly build walls up to 3–4 ft without engineering. Taller walls are possible with a stamped engineered plan — we'll walk you through the process.",
      },
      {
        q: "Will the wall hold up in Florida rain?",
        a: "Yes. Every wall we build includes a gravel base and drainage behind it so water can escape instead of blowing the wall out over time.",
      },
    ],
  },
  {
    slug: "pavers",
    title: "Pavers",
    short: "Patios, walkways & driveways built on a rock-solid base.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/ck920n9v_image.png",
    overview:
      "Paver patios, walkways, and driveways built the right way — excavated deep, compacted in lifts, bedded in screed sand, and finished with polymeric joint sand. Decorative finishes that last decades, not seasons.",
    includes: [
      "Excavation and deep compaction",
      "Crushed limerock base & screed sand bed",
      "Paver patios, walkways & driveways",
      "Custom patterns, borders & inlays",
      "Polymeric sand for weed-free joints",
      "Sealing options for long-term protection",
    ],
    faq: [
      {
        q: "Will the pavers sink or shift over time?",
        a: "Not when they're installed correctly. Our base prep is the difference — we compact in lifts and use the right aggregates so the surface stays level for the long haul.",
      },
      {
        q: "Can you match pavers I already have?",
        a: "Most of the time, yes. Bring us a sample or photo and we'll source a match for repairs, extensions, or additions.",
      },
    ],
  },
  {
    slug: "fencing",
    title: "Fencing",
    short: "Custom wood, vinyl & privacy fences — built to last Florida weather.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/6tg39nvw_image.png",
    overview:
      "Privacy, curb appeal, and property lines done right. We build and repair wood, vinyl, and horizontal-slat fences with post-set depth and hardware that stands up to Florida sun, storms, and salt air.",
    includes: [
      "Horizontal & vertical wood fences",
      "Vinyl / PVC privacy fences",
      "Custom gates & hardware",
      "Post-hole excavation & concrete set",
      "Fence repairs & panel replacements",
      "Staining & sealing options",
    ],
    faq: [
      {
        q: "How long does a wood fence last down here?",
        a: "With pressure-treated posts set in concrete and a good seal on the boards, expect 10–15+ years of solid service. We recommend a re-seal every 2–3 years to keep it looking sharp.",
      },
      {
        q: "Do you handle permits & HOA approvals?",
        a: "Yes — we'll pull permits where required and prep the drawings/specs needed for HOA approval before we break ground.",
      },
      {
        q: "Can you match or extend an existing fence?",
        a: "Absolutely. Send us a photo and we'll source matching materials for extensions, repairs, or panel replacements.",
      },
    ],
  },
  {
    slug: "irrigation",
    title: "Irrigation Repair & Install",
    short: "Sprinkler repairs, new zone installs & smart controllers.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/ksgbbkih_image.png",
    overview:
      "A broken head or leaking valve can waste hundreds of gallons a day and cost you a healthy lawn. We diagnose, repair, and install irrigation systems tuned for Florida — even coverage, no dry spots, no runoff.",
    includes: [
      "Sprinkler head & valve repairs",
      "Zone additions & full-system installs",
      "Broken line & leak repairs",
      "Rain-sensor & smart-controller upgrades",
      "System audits & efficiency tuning",
      "Backflow preventer inspection",
    ],
    faq: [
      {
        q: "My sprinklers turn on but the yard is still dry — what gives?",
        a: "Usually clogged heads, low pressure from a leak, or misaligned zones. We run a full system audit, walk each zone with you, and quote the fix on the spot.",
      },
      {
        q: "Can you tie in a smart controller so I can run it from my phone?",
        a: "Yes — Rachio, Rain Bird, and Hunter smart controllers with rain sensors and Wi-Fi control are our go-to. Cuts water bills and keeps grass green.",
      },
      {
        q: "Do you offer maintenance plans?",
        a: "Yes. Quarterly or seasonal irrigation tune-ups keep every head aimed, every zone timed right, and small issues caught before they become big ones.",
      },
    ],
  },


  {
    slug: "handyman",
    title: "Handyman",
    short: "Subcontract help & small repairs — the punch-list crew.",
    image:
      "https://customer-assets.emergentagent.com/job_craft-solutions-new/artifacts/rl6sdd3l_680258579_941537105535829_3341124945755979081_n.jpg",
    overview:
      "Need a reliable crew to knock out small repairs, or a licensed sub to take on a specialty portion of your project? That's us. We take on handyman work and sub-contracting for property owners, contractors, and property managers across Tampa Bay.",
    includes: [
      "Small repair punch-lists",
      "Sub-contracting for landscaping, drainage & hardscape scopes",
      "Fence and gate repairs",
      "Irrigation troubleshooting",
      "Pressure washing of hardscapes",
      "Light carpentry & exterior repairs",
    ],
    faq: [
      {
        q: "Do you take on sub-contracted scopes from other GCs?",
        a: "Yes — we regularly sub landscape, drainage, paver, and retaining-wall scopes for general contractors and property managers. Licensed, insured, and on-schedule.",
      },
      {
        q: "Is there a minimum for small repairs?",
        a: "Most handyman visits are billed at a 2-hour minimum. Larger projects are quoted up front with no surprises.",
      },
    ],
  },
];

export const FEATURES = [
  {
    title: "Comprehensive Services",
    body: "From landscaping and lawn maintenance to drainage, lighting, and handyman services — complete property solutions under one roof.",
    icon: "Boxes",
  },
  {
    title: "Reliable & Professional Team",
    body: "We show up on time, communicate clearly, and complete every job with attention to detail and care.",
    icon: "ShieldCheck",
  },
  {
    title: "Quality Workmanship",
    body: "Long-lasting solutions, proven methods, and quality materials that deliver results you can count on.",
    icon: "Hammer",
  },
  {
    title: "Customized Solutions",
    body: "Every property is different. We tailor our services to your specific needs, goals, and budget.",
    icon: "Settings2",
  },
  {
    title: "Residential & Commercial",
    body: "We proudly serve homeowners, businesses, and property managers with dependable, scalable service options.",
    icon: "Building2",
  },
  {
    title: "Locally Owned & Operated",
    body: "We're invested in our community and committed to earning your trust on every project.",
    icon: "MapPin",
  },
];

// Real Google reviews for ProCraft Solutions — pulled directly from the
// company's Google Maps profile (5.0 ★). Ordered most recent first.
export const REVIEWS = [
  {
    name: "Marc Sokol",
    initial: "M",
    color: "#4285F4",
    rating: 5,
    date: "a month ago",
    body:
      "Pro craft does an excellent job with landscape design as well as maintenance of our property including landscape maintenance, irrigation and outdoor lighting. They are very diligent, reliable and communicate very well. Highly recommend their services.",
    localGuide: false,
  },
  {
    name: "Barbara Turi",
    initial: "B",
    color: "#16A34A",
    rating: 5,
    date: "a month ago",
    body:
      "ProCraft Solutions is my go to provider for my rental property business. They are reliable, conscientious and professional. They meet all my landscaping needs. I highly recommend ProCraft Solutions.",
    localGuide: false,
  },
  {
    name: "Roger Corbin",
    initial: "R",
    color: "#EA4335",
    rating: 5,
    date: "a month ago",
    body:
      "John was great to work with, and he went above and beyond to get the job done. I highly recommend his company.",
    localGuide: false,
  },
  {
    name: "Ed Blasioli",
    initial: "E",
    color: "#FBBC04",
    rating: 5,
    date: "a month ago",
    body:
      "Jon and his team are very well mannered and respectful. Jon took over for another lawn company that destroyed my lawn. He has been diligently working with me to correct the issues and get my lawn back bougie status! I would consider him a leader in his craft. If I could give him 10 stars I would!!!! Thank you Jon for all your hard work.",
    localGuide: false,
  },
  {
    name: "Rich Ellis",
    initial: "R",
    color: "#4285F4",
    rating: 5,
    date: "3 months ago",
    body:
      "I had a great experience with this company replacing my fireplace cap and repairing the brickwork on my chimney. From start to finish, they were professional, knowledgeable, and easy to work with. They showed up on time, explained what needed to be done, and completed the work efficiently. The new cap looks solid, and the brick repair blends in beautifully with the existing chimney. It's clear they take pride in their craftsmanship.",
    localGuide: true,
  },
  {
    name: "Dianna Farnell",
    initial: "D",
    color: "#34A853",
    rating: 5,
    date: "3 months ago",
    body:
      "I had a great experience with this company. They did a thorough job fortifying my house against rodents, including resealing my garage door and repairing my soffit. Everything was explained clearly, the work was done efficiently, and the quality really shows. It's such a relief knowing my home is properly sealed and protected now. Professional, knowledgeable, and worth every penny—highly recommend!",
    localGuide: true,
  },
  {
    name: "Jesse McLaughlin",
    initial: "J",
    color: "#A142F4",
    rating: 5,
    date: "5 months ago",
    body:
      "Resodded my yard with St Augustine 3 1/2 weeks ago and it looks like it's been planted. Great job 5 stars. Will continue to use them for lawn maintenance as well.",
    localGuide: false,
  },
  {
    name: "Will Reed",
    initial: "W",
    color: "#FBBC04",
    rating: 5,
    date: "5 months ago",
    body:
      "They did an amazing job! Up and beyond my expectations. Was very detailed and specific on what he would do. Excellent work! Thanks guys!",
    localGuide: false,
  },
  {
    name: "Curtis Seitzer",
    initial: "C",
    color: "#16A34A",
    rating: 5,
    date: "5 months ago",
    body:
      "very professional easy to work with definitely recommend there the best around",
    localGuide: false,
  },
  {
    name: "Carroll Bernard",
    initial: "C",
    color: "#4285F4",
    rating: 5,
    date: "9 months ago",
    body:
      "Best lawn care service since we've found in Florida.",
    localGuide: false,
  },
  {
    name: "Patrick Clare",
    initial: "P",
    color: "#EA4335",
    rating: 5,
    date: "11 months ago",
    body:
      "We hired ProCraft Solutions to help us transform our grass front yard into a totally landscaped area without grass. They took our design ideas, made a few valuable suggestions and completed the job on-time and on-budget. We unconditionally recommend them. THANK YOU!",
    localGuide: false,
  },
  {
    name: "Amy Saillé",
    initial: "A",
    color: "#34A853",
    rating: 5,
    date: "a year ago",
    body:
      "John and his team have been taking care of our lawn for a few months and have done a great job. There's always a learning curve when switching lawn services and he takes feedback very well and always follows through the next week. He's responsive to messages as well. I would highly recommend this company.",
    localGuide: false,
  },
  {
    name: "Mario Barbara",
    initial: "M",
    color: "#FBBC04",
    rating: 5,
    date: "a year ago",
    body:
      "Johnny and his crew came through and got us squared away. We needed some curb appeal to get the house ready to sell, and he was on it! Prompt communication and extremely reasonable pricing. I've already recommended him to family and friends. Worth every dollar 🤌",
    localGuide: false,
  },
  {
    name: "Ellen Brady",
    initial: "E",
    color: "#A142F4",
    rating: 5,
    date: "a year ago",
    body:
      "Very knowledgeable with personalized service",
    localGuide: false,
  },
];
